<div class="req-shell">
    <aside class="req-sidebar">
        <div class="req-sidebar__brand">
            <span class="req-topbar__mark">
                <img *ngIf="companyLogo; else brandIcon" [src]="companyLogo" alt="" />
                <ng-template #brandIcon>
                    <mat-icon svgIcon="heroicons_outline:bolt"></mat-icon>
                </ng-template>
            </span>
            <span class="req-topbar__labels">
                <span class="req-topbar__name">{{ companyName || 'Prehox' }}</span>
                <span class="req-topbar__sub" autoTranslate>Central de remoções</span>
            </span>
        </div>

        <nav class="req-sidebar__nav">
            <a
                *ngFor="let tab of tabs"
                class="req-sidebar__link"
                [class.req-sidebar__link--on]="activeTab === tab.id"
                [class.req-sidebar__link--cta]="tab.id === 'request'"
                [routerLink]="tab.route"
            >
                <mat-icon [svgIcon]="tab.icon"></mat-icon>
                <span autoTranslate>{{ tab.label }}</span>
            </a>
        </nav>
    </aside>

    <div class="req-app">
        <header class="req-topbar">
            <div class="req-topbar__brand">
                <span class="req-topbar__mark">
                    <img *ngIf="companyLogo; else brandIconMobile" [src]="companyLogo" alt="" />
                    <ng-template #brandIconMobile>
                        <mat-icon svgIcon="heroicons_outline:bolt"></mat-icon>
                    </ng-template>
                </span>
                <span class="req-topbar__labels">
                    <span class="req-topbar__name">{{ companyName || 'Prehox' }}</span>
                    <span class="req-topbar__sub" autoTranslate>Central de remoções</span>
                </span>
            </div>

            <div class="req-topbar__actions">
                <button
                    type="button"
                    class="req-icon-btn req-icon-btn--theme"
                    [matTooltip]="themeToggleTooltip | autoTranslate"
                    (click)="cycleTheme()"
                >
                    <mat-icon [svgIcon]="themeToggleIcon"></mat-icon>
                </button>
                <a class="req-topbar__avatar" routerLink="/requester/profile">{{ initial }}</a>
            </div>
        </header>

        <main class="req-screen">
            <router-outlet></router-outlet>
        </main>

        <app-requester-tab-bar *ngIf="showTabBar" [activeTab]="activeTab"></app-requester-tab-bar>
    </div>
</div>
